module.exports = __webpack_public_path__ + "static/planet-890fc77aa431c6599c6e171825e1573e.svg";